module.exports = __webpack_public_path__ + "static/trumpet-c8805f36af5e6b3e8af3f3dbaa02bc0a.png";